var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('h2',{staticClass:"font-weight-light"},[_vm._v(_vm._s(_vm.project.client_name))]),_c('p',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.intro))]),_c('project-info',{attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }